import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function AnonymousBanner() {
  return (
    <Box
      gap="s12"
      flexDirection="row"
      paddingY="s12"
      alignItems="center"
      justifyContent="center"
      height="s48"
      background="malibu200"
      border={{
        bottom: {
          style: 'solid',
          width: 's1',
          color: 'darker160',
        },
      }}
    >
      <Icon.Medium color="grey1000" icon="lock-locked" />
      <Text.Normal size="300" weight="medium" color="grey1000">
        {i18n.t('surveys.form.response.anonymous')}
      </Text.Normal>
    </Box>
  )
}
